module.exports = __webpack_public_path__ + "img/s_01.1d71a244.png";